import React from 'react';
import './services-page.css';

const servicesData = [
  {
    id: '01',
    icon: 'la-hard-hat',
    title: 'Architecture & Exterior Design',
    link: '/innerpages/services/architecture-exterior-design',
    image: '/home1/assets/img/services/ser1.jpg',
    text:
      'We create architectural spaces that combine functionality, innovation, and timeless aesthetics. From concept planning to stunning exterior facades, every design is tailored to reflect your vision while ensuring durability, efficiency, and lasting value.',
    points: [
      'Concept planning through to detailed design',
      'Striking, functional exterior facades',
      'Built for durability & long-term value',
    ],
  },
  {
    id: '02',
    icon: 'la-bezier-curve',
    title: 'Interior Design',
    link: '/innerpages/services/interior-design',
    image: '/home1/assets/img/services/ser2.jpg',
    text:
      'We design interiors that are elegant, practical, and personalized to your lifestyle or business. Every detail, from space planning and lighting to materials and finishes, is carefully considered to create spaces that are both beautiful and functional.',
    points: [
      'Personalized space planning',
      'Considered lighting, materials & finishes',
      'Elegant, functional interiors',
    ],
  },
  {
    id: '03',
    icon: 'la-bed',
    title: 'Furniture Design',
    link: '/innerpages/services/furniture-design',
    image: '/home1/assets/img/services/ser3.jpg',
    text:
      'Our custom furniture solutions are crafted to complement your interiors with the perfect balance of style, comfort, and functionality. Each piece is thoughtfully designed using quality materials to maximize space while reflecting your unique taste.',
    points: [
      'Custom pieces tailored to your space',
      'Quality materials, lasting comfort',
      'Designed to reflect your taste',
    ],
  },
  {
    id: '04',
    icon: 'la-comments',
    title: 'Project Consultation',
    link: '/innerpages/services/project-consultation',
    image: '/home1/assets/img/services/ser4.jpg',
    text:
      'We provide end-to-end project consultation to ensure a smooth and successful execution. From planning and budgeting to material selection, vendor coordination, and site supervision, we guide you through every stage of the project with expertise and transparency.',
    points: [
      'Planning & budgeting guidance',
      'Material selection & vendor coordination',
      'On-site supervision, start to finish',
    ],
  },
];

function Services() {
  return (
    <section className="tc-services-style1 services-pg-style2">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center intro-row">
            <p className="color-666 text-uppercase wow"> our services </p>
            <h2 className="sub-title fsz-45 mt-20 wow fadeInUp" data-wow-delay="0.1s">
              Complete design & build services, under one roof
            </h2>
          </div>

          <div className="services-list">
            {servicesData.map((service, index) => (
              <div
                className={`service-row wow fadeInUp ${index % 2 === 1 ? 'reverse' : ''}`}
                data-wow-delay={`0.${index + 2}s`}
                key={service.id}
              >
                <div className="service-row-img">
                  <a href={service.link} className="img-wrap">
                    <img src={service.image} alt={service.title} className="img-cover" />
                  </a>
                  <span className="service-index bg-orange1 text-white">{service.id}</span>
                </div>

                <div className="service-row-content">
                  <div className="icon color-orange1">
                    <i className={`la ${service.icon}`}></i>
                  </div>
                  <h3 className="fsz-24 mb-20">
                    <a href={service.link}>{service.title}</a>
                  </h3>
                  <div className="text color-666 mb-30">{service.text}</div>
                  <ul className="service-points color-666">
                    {service.points.map((point, i) => (
                      <li key={i}>
                        <i className="ti-check color-orange1"></i> {point}
                      </li>
                    ))}
                  </ul>
                  <a href={service.link} className="service-link">
                    Explore Service <i className="ti-arrow-top-right"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="/innerpages/contact"
              className="butn rounded-pill mt-80 hover-bg-black bg-orange1 text-white"
            >
              <span>
                Contact Us
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
